"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const query = (0, client_1.gql) `
  query queryOrgDeletable($orgId: String!) {
  queryOrgDeletable(orgId: $orgId)
}
`;
exports.default = query;
//# sourceMappingURL=isDeletebleOrganization.js.map